import { Pipe, PipeTransform } from '@angular/core';
import { isNil, isString, Nillable } from '@web/utils';

@Pipe({
  name: 'toString',
  standalone: true,
})
export class ToStringPipe<Value> implements PipeTransform {
  public transform(value: Nillable<Value>): Nillable<string> {
    if (isNil(value)) {
      return value;
    }

    if (isString(value)) {
      return value;
    }

    return JSON.stringify(value);
  }
}
